import React from 'react'
import classNames from 'classnames'
import Cookies from 'js-cookie'
import Button from '../../components/common/button'
import { CloseSmall } from '../../components/common/svg-icons'
import './cookie-banner.sass'

class CookieBanner extends React.Component {
  cookieName = '_JSGDPRAGR'

  state = {
    isShowed: false,
  }

  componentDidMount() {
    const cookie = Cookies.get(this.cookieName)

    if (cookie !== 'true') {
      setTimeout(() => {
        this.setState({ isShowed: true })
      }, 3000)
    }  else  {
      window.initGTM && window.initGTM()
    }
  }

  handleAgree = () => {
    Cookies.set(this.cookieName, 'true', { expires: 365, path: '/' })
    window.initGTM && window.initGTM()
    this.setState({ isShowed: false })
  }

  render() {
    return (
      <div className={classNames('cookie-banner', { showed: this.state.isShowed })}>
        <div className="cookie-banner__close-button">
          <CloseSmall onClick={this.handleAgree} />
        </div>
        <p>
          We&nbsp;use cookies to&nbsp;offer you a&nbsp;better experience and send our online
          advertising messages in&nbsp;line with your preferences. Consult the {' '}
          <a href="https://flyxo.com/legal/cookies-notice/">Cookie&nbsp;Policy</a>{' '}
          to&nbsp;find out more. By&nbsp;closing this banner or&nbsp;continuing to&nbsp;browse, you
          consent to&nbsp;the use of&nbsp;cookies.
        </p>
        <div className="cookie-banner__button">
          <Button isSmall isFluid onClick={this.handleAgree}>
            Agree
          </Button>
        </div>
      </div>
    )
  }
}

export default CookieBanner
